export default "__VITE_ASSET__Dar0Vp8D__"